import { Box, Button, TextField, makeStyles } from '@material-ui/core';
import React, { FC, useState } from 'react';
import { ChromePicker } from 'react-color';
import { useDispatch } from 'react-redux';
import useComponentVisible from 'src/hooks/useComponentVisible';
import colorRectangle from 'src/images/colorRectangle.png';
import { RootState, useSelector } from 'src/store';
import {
  editText,
  editFontWeight,
  editColor,
  editFontSize,
  editTextAlign,
  editFontFamily
} from 'src/store/modules/editText';

import Plus from 'src/components/Icon/Plus';
import Minus from 'src/components/Icon/Minus';
import AlignLeft from 'src/components/Icon/AlignLeft';
import AlignCenter from 'src/components/Icon/AlignCenter';
import AlignRight from 'src/components/Icon/AlignRight';

import ChevronUp from 'src/components/Icon/ChevronUp';
import ChevronDown from 'src/components/Icon/ChevronDown';
import FontFamilyPicker from 'src/components/editor/FontFamilyPicker';

interface editTextProps {
  type: string;
}

const useStyles = makeStyles(() => ({
  boxWrapper: {
    // margin: '0 0.5rem',
    display: 'flex',
    justifyContent: 'space-between'
  },
  textAlign: {
    cursor: 'pointer'
  }
}));

const EditTextAlign: FC<editTextProps> = ({ type }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const handleTextAlign = (align: string) => {
    const newTextAlign = JSON.parse(JSON.stringify(textAlign));
    newTextAlign[type] = align;
    dispatch(editTextAlign(newTextAlign));
  };

  return (
    <Box className={classes.boxWrapper}>
      <div
        style={{
          display: 'flex',
          // flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '1rem'
        }}
      >
        <div
          onClick={() => handleTextAlign('left')}
          className={classes.textAlign}
          style={{
            width: '1.5rem',
            height: '1.5rem'
          }}
        >
          <AlignLeft
            stroke={textAlign[type] === 'left' ? '#000000' : '#BDBDBD'}
          />
        </div>
        <div
          onClick={() => handleTextAlign('center')}
          className={classes.textAlign}
          style={{
            width: '1.5rem',
            height: '1.5rem'
          }}
        >
          <AlignCenter
            stroke={textAlign[type] === 'center' ? '#000000' : '#BDBDBD'}
          />
        </div>
        <div
          onClick={() => handleTextAlign('right')}
          className={classes.textAlign}
          style={{
            width: '1.5rem',
            height: '1.5rem'
          }}
        >
          <AlignRight
            stroke={textAlign[type] === 'right' ? '#000000' : '#BDBDBD'}
          />
        </div>
      </div>
    </Box>
  );
};

export default EditTextAlign;
